export const STATUS_LOADING = 'LOADING';
export const STATUS_READY = 'READY';
export const DEFAULT_STATUS = STATUS_LOADING;
